import axios from 'axios';

const api = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL || '/api',
});

api.interceptors.request.use((config) => {
  if (typeof window !== 'undefined') {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (typeof window !== 'undefined' && error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      const current = `${window.location.pathname}${window.location.search}${window.location.hash}`;
      const redirect = encodeURIComponent(current);
      window.location.href = `/zh-tw/login?redirect=${redirect}`;
    }
    return Promise.reject(error);
  }
);

export default api;
